import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesOverview() {
  const { t } = useTranslation();

  const services = [
    {
      id: 'water',
      titleKey: 'svc_water_title',
      subtitleKey: 'svc_water_sub',
      descKey: 'svc_water_desc',
      benefits: ['svc_water_b1', 'svc_water_b2', 'svc_water_b3', 'svc_water_b4'],
      ctaKey: 'svc_water_cta',
      badgeKey: 'svc_water_badge',
      link: '/water-purification',
      icon: 'ri-drop-fill',
      iconBg: 'bg-sky-50',
      iconColor: 'text-sky-600',
      img: 'https://public.readdy.ai/ai/img_res/bf96bc9afa48e801348f249c34a7e8d8.jpg',
    },
    {
      id: 'windows',
      titleKey: 'svc_win_title',
      subtitleKey: 'svc_win_sub',
      descKey: 'svc_win_desc',
      benefits: ['svc_win_b1', 'svc_win_b2', 'svc_win_b3', 'svc_win_b4'],
      ctaKey: 'svc_win_cta',
      badgeKey: 'svc_win_badge',
      link: '/windows-services',
      icon: 'ri-home-gear-line',
      iconBg: 'bg-slate-50',
      iconColor: 'text-slate-700',
      img: 'https://readdy.ai/api/search-image?query=professional%20window%20installation%20replacement%20service%20contractor%20installing%20large%20energy%20efficient%20double%20pane%20windows%20American%20home%20exterior%20view%2C%20quality%20craftsmanship%2C%20sunny%20day%2C%20residential%20suburban%20neighborhood%2C%20before%20and%20after%20transformation&width=700&height=500&seq=orpm-service-windows-v2&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-sky-600 text-sm font-bold uppercase tracking-widest">{t('svc_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-800 mt-3 mb-4">
            {t('svc_title')}
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            {t('svc_desc')}
          </p>
        </div>

        {/* Service Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group rounded-2xl overflow-hidden border border-slate-100 bg-white hover:border-sky-100 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.img}
                  alt={t(service.titleKey)}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-5">
                  <span className="bg-sky-500 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wide">
                    {t(service.badgeKey)}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-start gap-4 mb-5">
                  <div className={`w-12 h-12 ${service.iconBg} rounded-xl flex items-center justify-center shrink-0`}>
                    <i className={`${service.icon} ${service.iconColor} text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-800 leading-tight">{t(service.titleKey)}</h3>
                    <p className="text-sky-600 text-sm font-semibold mt-0.5">{t(service.subtitleKey)}</p>
                  </div>
                </div>

                <p className="text-slate-600 text-sm leading-relaxed mb-6">{t(service.descKey)}</p>

                <ul className="space-y-2.5 mb-7">
                  {service.benefits.map((bKey) => (
                    <li key={bKey} className="flex items-center gap-3 text-sm text-slate-700">
                      <div className="w-4 h-4 flex items-center justify-center shrink-0">
                        <i className="ri-check-line text-sky-500 text-base font-bold"></i>
                      </div>
                      {t(bKey)}
                    </li>
                  ))}
                </ul>

                <Link
                  to={service.link}
                  className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-bold text-sm group/link cursor-pointer"
                >
                  {t(service.ctaKey)}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base group-hover/link:translate-x-1 transition-transform"></i>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
